<!-- MasterBookのサイトURL表示 -->
<template>
  <div class="column-body">
    <div class="buttons">
      <ExternalLinkButton :url="url" title="チケットの特徴ページ" />
    </div>
  </div>
</template>

<script>
import ExternalLinkButton from "@/views/Components/Atoms/ExternalLinkButton.vue";
export default {
  name: "MbTicketUrl",
  components: { ExternalLinkButton: ExternalLinkButton },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.column-body {
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  color: #ffb206;
  margin-bottom: 10px;
}
</style>
